import { getSettingsGenericError } from './chunk-TDNRUBPG.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import mapValues from 'lodash/mapValues';
import * as yup from 'yup';

var getKitchenTicketSettingsError = (jsonString, obj) => {
  const jsonObj = JSON.parse(jsonString);
  const newObj = {};
  Object.keys(obj).forEach((key) => {
    newObj[`${obj.prepStationId}-${key}`] = jsonObj[key];
  });
  return newObj;
};
var prepStationVersionSchema = yup.lazy(
  (obj) => yup.object(
    mapValues(
      obj,
      (prepStationVersion) => yup.object({
        updateOrderNewText: yup.string().trim().required(
          getKitchenTicketSettingsError(
            JSON.stringify(
              getSettingsGenericError({
                key: "updateOrderNewText",
                id: "updateOrderNewText",
                message: i18n_config_default.t(
                  "settingsModule.kitchenTicketSettings.errors.ticketDisplay.updateOrderNewText"
                ),
                section: "updateOrderDisplay" /* UPDATE_ORDER_DISPLAY */
              })
            ),
            prepStationVersion
          )
        ),
        updateOrderVoidText: yup.string().trim().required(
          getKitchenTicketSettingsError(
            JSON.stringify(
              getSettingsGenericError({
                key: "updateOrderVoidText",
                id: "updateOrderVoidText",
                message: i18n_config_default.t(
                  "settingsModule.kitchenTicketSettings.errors.ticketDisplay.updateOrderVoidText"
                ),
                section: "updateOrderDisplay" /* UPDATE_ORDER_DISPLAY */
              })
            ),
            prepStationVersion
          )
        )
      })
    )
  )
);
var kitchenTicketSettingsSchema = yup.object().shape({
  prepStationVersions: prepStationVersionSchema
});

export { kitchenTicketSettingsSchema, prepStationVersionSchema };
